import { ReactNode, ElementType } from "react";
import { IconType } from "react-icons";

interface SummaryCardProps {
  icon?: IconType | ElementType;
  title: string;
  value: ReactNode;
  footer?: ReactNode;
  footerLabel?: string;
  onFooterClick?: () => void;
}

const footerTextClass =
  "mt-2 pt-1 text-xs text-gray-500 dark:text-gray-400";

export const SummaryCard = ({
  icon: Icon,
  title,
  value,
  footer,
  footerLabel,
  onFooterClick,
}: SummaryCardProps) => {
  const renderFooter = () => {
    if (footer !== undefined) return footer;

    const label = footerLabel ?? (onFooterClick ? "Ver detalhes" : undefined);
    if (!label) return null;

    if (onFooterClick) {
      return (
        <button
          type="button"
          onClick={onFooterClick}
          className={`${footerTextClass} text-left transition hover:text-brand-dark dark:hover:text-gray-200`}
        >
          {label}
        </button>
      );
    }

    return <p className={footerTextClass}>{label}</p>;
  };

  return (
    <div className="summary-card min-w-0 w-full">
      <div className="flex min-w-0 items-center gap-2">
        {Icon && (
          <div className="summary-card-icon">
            <Icon className="h-4 w-4 text-[#e7a73f]" />
          </div>
        )}
        <p className="min-w-0 flex-1 text-xs leading-snug text-gray-500 dark:text-gray-400">{title}</p>
      </div>
      <p className="mt-2 break-words text-xl font-bold leading-tight text-brand-dark dark:text-gray-100">{value}</p>
      {renderFooter()}
    </div>
  );
};
